/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as routePath from "../../../../routes"
import * as apiEndpoint from "../../../../apis/postlogin/PostloginApis"
import { getAddress } from "../../../../utilsfunction/GetApis";
import Error from "../../../../components/Alert/Error";
import { deleteRequest, postRequest, putRequest } from "../../../../interceptor/AxiosConfig";
// import ErrorMessageHandling from "../../../../utilsfunction/ErrorHandling";
import Success from "../../../../components/Alert/Success";
import AddAddressModal from "../../../../components/modals/AddAddressModal";
import EditAddressModal from "../../../../components/modals/EditAddressModal";
// import { LocalStorage } from "../../../../utilsfunction/Encrypt";

const AddressCard = () => {
    const navigate = useNavigate()
    // const localstorage = new LocalStorage();
    const [addresses, setAddresses] = useState(null);
    // const userLocation = localstorage.getItem("userLocation")
    const [errorMessage, setErrorMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false)

    const [showAddAddress, setShowAddAddressModal] = useState(false);

    const [showEditAddress, setShowEditAddressModal] = useState(false);


    // adding addresses
    const initialState = {
        location_name: null,
        address_line1: null,
        address_line2: null,
        block: null,
        house_number: null,
        city: null,
        state: null,
        postal_code: null,
        country: null,
        latitude: null,
        longitude: null
    }

    const [addressValues, setAddressValues] = useState(initialState);
    const [addressEdit, setEditAddress] = useState(null)
    const [formErrors, setFormErrors] = useState({});
    const [isSubmit, setIsSubmit] = useState(false);

    // api for creating the address
    const createAddress = async () => {
        await postRequest(`${apiEndpoint.AddAddressAPIEndpoint}`, addressValues)
            .then((response) => {
                if (response.status === 201) {
                    setSuccessMessage(response.data.message)
                    setErrorMessage(false)
                    setShowAddAddressModal(false)
                    getAddress(setAddresses, setErrorMessage)
                    setAddressValues(null)
                }
            }).catch((err) => {
                // setErrorMessage(ErrorMessageHandling(err))
                // setErrorMessage("")
                setSuccessMessage(false)
                setShowAddAddressModal(false)
            })
    }

    // setting the fields values
    const onHandleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setAddressValues({ ...addressValues, [name]: value });
    };

    // setting the fields for editing
    const onHandleEditChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setAddressValues({ ...addressEdit, [name]: value });
    };

    // validating the fields
    const validate = (values) => {
        const errors = {};
        if (!values.block) {
            errors.block = "Apartment/Road/Area is required!"
        }
        if (!values.house_number) {
            errors.house_number = "House/Flat number is required!"
        }
        if (!values.location_name) {
            errors.location_name = "Location is required!";
        }
        if (!values.type) {
            errors.type = "Address type is required!";
        }
        return errors;
    };

    // function for handling create button event
    const handleAddAddress = (e) => {
        e.preventDefault();
        setFormErrors(validate(addressValues));
        setIsSubmit(true);
    };

    useEffect(() => {
        // if there is no errors function will be called
        if (Object.keys(formErrors).length === 0 && isSubmit) {
            createAddress();
        }
    }, [formErrors, isSubmit]);

    useEffect(() => {
        getAddress(setAddresses, setErrorMessage)
    }, [])

    const handleDelete = async (id) => {
        // setAddresses(addresses.filter((address) => address.id !== id));
        await deleteRequest(`${apiEndpoint.deleteAddressAPIEndpoint}/${id}`)
            .then((res) => {
                if (res.status === 200) {
                    setSuccessMessage(res.data.message)
                    setErrorMessage(false)
                    getAddress(setAddresses, setErrorMessage)
                }
            }).catch((err) => {
                // setErrorMessage(ErrorMessageHandling(err))
                // setErrorMessage("")
                setSuccessMessage(false)
            })
    };

    // handling the edit functionality
    const handleEditAddress = async (id) => {
        await putRequest(`${apiEndpoint.editAddressAPIEndpoint}/${id}`, addressValues)
            .then((res) => {
                if (res.status === 200) {
                    setSuccessMessage(res.data.message)
                    setErrorMessage(false)
                    setShowEditAddressModal(false)
                    getAddress(setAddresses, setErrorMessage)
                }
            }).catch((err) => {
                // setErrorMessage(ErrorMessageHandling(err))
                // setErrorMessage("")
                setSuccessMessage(false)
            })
    };

    // for setting the default address

    // State to store which checkbox is selected
    const [selectedCheckbox, setSelectedCheckbox] = useState(null);

    // Function to handle checkbox selection
    const onHandleAddressCheck = (event, id) => {
        const checkboxValue = event.target.value;

        setSuccessMessage(false)
        setErrorMessage(false)

        if (selectedCheckbox === checkboxValue) {
            setSelectedCheckbox(null);
        } else {
            setSelectedCheckbox(checkboxValue);
            setDefaultAddress(id)
        }
    };

    const setDefaultAddress = async (id) => {
        await postRequest(`${apiEndpoint.defaultAddressAPIEndpoint}`, {
            address_id: id
        }).then((res) => {
            if (res.status === 200) {
                setSuccessMessage(res.data.message)
                setErrorMessage(false)
                getAddress(setAddresses, setErrorMessage)
            }
        }).catch((err) => {
            // setErrorMessage(ErrorMessageHandling(err))
            // setErrorMessage("")
            setSuccessMessage(false)
        })
    }

    return (
        <div className="container mx-auto py-8 min-h-screen">
            {errorMessage && <Error errorMessage={errorMessage} />}
            {successMessage && <Success successMessage={successMessage} />}
            <div className="px-4 ps-0 pb-4 breadcrump">
                <div className="flex gap-2">
                    <span className="heading_first cursor-pointer" onClick={() => navigate(`/${routePath.CustomerLayoutPath}/${routePath.profilePath}`)}>Profile</span>

                    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.98027 6.9999C7.98027 7.25081 7.88447 7.50168 7.69327 7.69297L1.67362 13.7126C1.29069 14.0955 0.669847 14.0955 0.287077 13.7126C-0.0956924 13.3298 -0.0956924 12.7091 0.287077 12.3261L5.6136 6.9999L0.287263 1.67366C-0.0955064 1.29073 -0.0955064 0.670073 0.287263 0.287333C0.670033 -0.0957766 1.29088 -0.0957766 1.6738 0.287333L7.69346 6.30683C7.88469 6.49822 7.98027 6.74909 7.98027 6.9999Z" fill="#1B9075" />
                    </svg>

                    <span className="heading_second">Address</span>
                </div>
            </div>
            <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {addresses?.map((address, index) => (
                    <div className="flex flex-col">
                        <div
                            key={address.id}
                            className="addressHeadBg p-4 relative"
                        >
                            <div className="flex justify-between items-center">
                                <div className="flex gap-6 items-center">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_6606_13230)">
                                            <path d="M7 14C7 14.2652 6.89464 14.5196 6.70711 14.7071C6.51957 14.8946 6.26522 15 6 15H5C4.73478 15 4.48043 14.8946 4.29289 14.7071C4.10536 14.5196 4 14.2652 4 14C4 13.7348 4.10536 13.4804 4.29289 13.2929C4.48043 13.1054 4.73478 13 5 13H6C6.26522 13 6.51957 13.1054 6.70711 13.2929C6.89464 13.4804 7 13.7348 7 14ZM11 13H10C9.73478 13 9.48043 13.1054 9.29289 13.2929C9.10536 13.4804 9 13.7348 9 14C9 14.2652 9.10536 14.5196 9.29289 14.7071C9.48043 14.8946 9.73478 15 10 15H11C11.2652 15 11.5196 14.8946 11.7071 14.7071C11.8946 14.5196 12 14.2652 12 14C12 13.7348 11.8946 13.4804 11.7071 13.2929C11.5196 13.1054 11.2652 13 11 13ZM6 17H5C4.73478 17 4.48043 17.1054 4.29289 17.2929C4.10536 17.4804 4 17.7348 4 18C4 18.2652 4.10536 18.5196 4.29289 18.7071C4.48043 18.8946 4.73478 19 5 19H6C6.26522 19 6.51957 18.8946 6.70711 18.7071C6.89464 18.5196 7 18.2652 7 18C7 17.7348 6.89464 17.4804 6.70711 17.2929C6.51957 17.1054 6.26522 17 6 17ZM11 17H10C9.73478 17 9.48043 17.1054 9.29289 17.2929C9.10536 17.4804 9 17.7348 9 18C9 18.2652 9.10536 18.5196 9.29289 18.7071C9.48043 18.8946 9.73478 19 10 19H11C11.2652 19 11.5196 18.8946 11.7071 18.7071C11.8946 18.5196 12 18.2652 12 18C12 17.7348 11.8946 17.4804 11.7071 17.2929C11.5196 17.1054 11.2652 17 11 17ZM6 5H5C4.73478 5 4.48043 5.10536 4.29289 5.29289C4.10536 5.48043 4 5.73478 4 6C4 6.26522 4.10536 6.51957 4.29289 6.70711C4.48043 6.89464 4.73478 7 5 7H6C6.26522 7 6.51957 6.89464 6.70711 6.70711C6.89464 6.51957 7 6.26522 7 6C7 5.73478 6.89464 5.48043 6.70711 5.29289C6.51957 5.10536 6.26522 5 6 5ZM11 5H10C9.73478 5 9.48043 5.10536 9.29289 5.29289C9.10536 5.48043 9 5.73478 9 6C9 6.26522 9.10536 6.51957 9.29289 6.70711C9.48043 6.89464 9.73478 7 10 7H11C11.2652 7 11.5196 6.89464 11.7071 6.70711C11.8946 6.51957 12 6.26522 12 6C12 5.73478 11.8946 5.48043 11.7071 5.29289C11.5196 5.10536 11.2652 5 11 5ZM6 9H5C4.73478 9 4.48043 9.10536 4.29289 9.29289C4.10536 9.48043 4 9.73478 4 10C4 10.2652 4.10536 10.5196 4.29289 10.7071C4.48043 10.8946 4.73478 11 5 11H6C6.26522 11 6.51957 10.8946 6.70711 10.7071C6.89464 10.5196 7 10.2652 7 10C7 9.73478 6.89464 9.48043 6.70711 9.29289C6.51957 9.10536 6.26522 9 6 9ZM11 9H10C9.73478 9 9.48043 9.10536 9.29289 9.29289C9.10536 9.48043 9 9.73478 9 10C9 10.2652 9.10536 10.5196 9.29289 10.7071C9.48043 10.8946 9.73478 11 10 11H11C11.2652 11 11.5196 10.8946 11.7071 10.7071C11.8946 10.5196 12 10.2652 12 10C12 9.73478 11.8946 9.48043 11.7071 9.29289C11.5196 9.10536 11.2652 9 11 9ZM24 10V19C23.9984 20.3256 23.4711 21.5964 22.5338 22.5338C21.5964 23.4711 20.3256 23.9984 19 24H5C3.67441 23.9984 2.40356 23.4711 1.46622 22.5338C0.528882 21.5964 0.00158786 20.3256 0 19L0 5C0.00158786 3.67441 0.528882 2.40356 1.46622 1.46622C2.40356 0.528882 3.67441 0.00158786 5 0L11 0C12.3256 0.00158786 13.5964 0.528882 14.5338 1.46622C15.4711 2.40356 15.9984 3.67441 16 5H19C20.3256 5.00159 21.5964 5.52888 22.5338 6.46622C23.4711 7.40356 23.9984 8.67441 24 10ZM5 22H14V5C14 4.20435 13.6839 3.44129 13.1213 2.87868C12.5587 2.31607 11.7956 2 11 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22ZM22 10C22 9.20435 21.6839 8.44129 21.1213 7.87868C20.5587 7.31607 19.7956 7 19 7H16V22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V10ZM19 13C18.8022 13 18.6089 13.0586 18.4444 13.1685C18.28 13.2784 18.1518 13.4346 18.0761 13.6173C18.0004 13.8 17.9806 14.0011 18.0192 14.1951C18.0578 14.3891 18.153 14.5673 18.2929 14.7071C18.4327 14.847 18.6109 14.9422 18.8049 14.9808C18.9989 15.0194 19.2 14.9996 19.3827 14.9239C19.5654 14.8482 19.7216 14.72 19.8315 14.5556C19.9414 14.3911 20 14.1978 20 14C20 13.7348 19.8946 13.4804 19.7071 13.2929C19.5196 13.1054 19.2652 13 19 13ZM19 17C18.8022 17 18.6089 17.0586 18.4444 17.1685C18.28 17.2784 18.1518 17.4346 18.0761 17.6173C18.0004 17.8 17.9806 18.0011 18.0192 18.1951C18.0578 18.3891 18.153 18.5673 18.2929 18.7071C18.4327 18.847 18.6109 18.9422 18.8049 18.9808C18.9989 19.0194 19.2 18.9996 19.3827 18.9239C19.5654 18.8482 19.7216 18.72 19.8315 18.5556C19.9414 18.3911 20 18.1978 20 18C20 17.7348 19.8946 17.4804 19.7071 17.2929C19.5196 17.1054 19.2652 17 19 17ZM19 9C18.8022 9 18.6089 9.05865 18.4444 9.16853C18.28 9.27841 18.1518 9.43459 18.0761 9.61732C18.0004 9.80004 17.9806 10.0011 18.0192 10.1951C18.0578 10.3891 18.153 10.5673 18.2929 10.7071C18.4327 10.847 18.6109 10.9422 18.8049 10.9808C18.9989 11.0194 19.2 10.9996 19.3827 10.9239C19.5654 10.8482 19.7216 10.72 19.8315 10.5556C19.9414 10.3911 20 10.1978 20 10C20 9.73478 19.8946 9.48043 19.7071 9.29289C19.5196 9.10536 19.2652 9 19 9Z" fill="#374957" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_6606_13230">
                                                <rect width="24" height="24" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>

                                    <span className="addressBoxHead">Address {index + 1}</span>
                                </div>
                                <div className="absolute top-2 right-2 flex space-x-2">
                                    <button
                                        onClick={() => { setShowEditAddressModal(!showEditAddress); setEditAddress(address) }}
                                        className="text-gray-500 hover:text-gray-700"
                                    >
                                        <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="15.5" cy="15.5" r="15.5" fill="white" />
                                            <path d="M9.06339 17.7098L7.1747 23.1383L7.01805 23.589C6.93257 23.8357 7.16516 24.0683 7.41189 23.9828L7.86261 23.8262L13.2911 21.9375C13.3267 21.9256 13.3599 21.9067 13.386 21.8806L9.12026 17.6147C9.09421 17.641 9.07514 17.6742 9.06339 17.7098Z" fill="#202D34" />
                                            <path d="M23.4061 9.00192L21.9967 7.59256C21.2067 6.80248 19.9253 6.80248 19.1353 7.59256L17.7188 9.00907L21.9894 13.2797L23.4059 11.8632C24.1962 11.0733 24.1962 9.79216 23.4061 9.00192Z" fill="#202D34" />
                                            <path d="M17.0096 9.72087L9.83008 16.9004L14.1007 21.171L21.2802 13.9915L17.0096 9.72087Z" fill="#202D34" />
                                        </svg>

                                    </button>
                                    <button
                                        onClick={() => handleDelete(address.id)}
                                        className="text-gray-500 hover:text-gray-700"
                                    >
                                        <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="15.5" cy="15.5" r="15.5" fill="white" />
                                            <path d="M22.15 8.29646H18.4457V8.25938C18.4457 7.55554 17.8901 7 17.1863 7H14.6675C13.9636 7 13.4081 7.55567 13.4081 8.25938V8.29646H9.70384C9.31483 8.29646 9 8.6113 9 9.0003V9.70413C9 10.0931 9.31484 10.408 9.70384 10.408H22.1501C22.5391 10.408 22.8539 10.0931 22.8539 9.70413V9.0003C22.8538 8.61128 22.539 8.29646 22.15 8.29646Z" fill="#202D34" />
                                            <path d="M21.224 11.3707H10.6298C10.4261 11.3707 10.2779 11.5374 10.2965 11.7411L10.8151 22.4649C10.8706 23.6503 11.8523 24.5948 13.0376 24.5948H18.7977C19.9831 24.5948 20.9647 23.6687 21.0202 22.4649L21.5388 11.7411C21.5759 11.5559 21.4092 11.3706 21.224 11.3706L21.224 11.3707ZM14.7786 21.7241C14.7786 22.0574 14.5193 22.3168 14.1858 22.3168C13.8525 22.3168 13.5931 22.0576 13.5931 21.7241L13.5932 14.26C13.5932 13.9267 13.8525 13.6673 14.186 13.6673C14.5193 13.6673 14.7787 13.9266 14.7787 14.26L14.7786 21.7241ZM18.2606 21.7241C18.2606 22.0574 18.0013 22.3168 17.6678 22.3168C17.3345 22.3168 17.0751 22.0576 17.0751 21.7241L17.0752 14.26C17.0752 13.9267 17.3345 13.6673 17.6679 13.6673C18.0013 13.6673 18.2607 13.9266 18.2607 14.26L18.2606 21.7241Z" fill="#202D34" />
                                        </svg>

                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col addressBodyBg">
                            <div className="flex flex-col gap-2 justify-center p-16 pt-4 pb-8">
                                <div className="flex flex-col gap-1">
                                    <p className="addresssub_head">Apartment/Road/Area</p>
                                    <p className="addresssub_text">{address.block}</p>
                                </div>
                                <div className="address_border"></div>
                                <div className="flex gap-2">
                                    <div className="flex flex-col gap-1">
                                        <p className="addresssub_head">House/Flat No</p>
                                        <p className="addresssub_text">{address.house_number}</p>
                                    </div>
                                    <div className="flex flex-col gap-1">
                                        <p className="addresssub_head">Location's Name</p>
                                        <p className="addresssub_text">{address.location_name}</p>
                                    </div>
                                </div>
                                <div className="address_border"></div>
                                <div className="flex gap-2">
                                    <div className="flex flex-col gap-1">
                                        <p className="addresssub_head">Address Type</p>
                                        <p className="addresssub_text">{address.type}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="address_border"></div>
                            <div className="flex gap-4 items-center p-4">
                                <input type="checkbox" value={"address" + index} disabled={address?.default_address} checked={address?.default_address || selectedCheckbox === ("address" + index)} name={"address" + index} onChange={(e) => onHandleAddressCheck(e, address?.id)} />
                                {address?.default_address ? <h2 className="subtext">Default Address</h2> : <h2 className="subtext">Set default Address</h2>}
                            </div>
                        </div>
                    </div>
                ))}
                <div className="bg-green-50 p-4 rounded-lg border border-dashed border-green-500 flex justify-center items-center cursor-pointer"
                    onClick={() => { setShowAddAddressModal(!showAddAddress) }}
                >
                    <div className="flex flex-col gap-2 justify-center items-center">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22.7999 10.8H13.2V1.19992C13.2 0.537669 12.6624 0 11.9999 0C11.3376 0 10.8 0.537669 10.8 1.19992V10.8H1.19992C0.537669 10.8 0 11.3376 0 11.9999C0 12.6624 0.537669 13.2 1.19992 13.2H10.8V22.7999C10.8 23.4623 11.3376 24 11.9999 24C12.6624 24 13.2 23.4623 13.2 22.7999V13.2H22.7999C23.4623 13.2 24 12.6624 24 11.9999C24 11.3376 23.4623 10.8 22.7999 10.8Z" fill="#1B9075" />
                        </svg>
                        <p className="addAddressBtnTxt">Add New Address</p>
                    </div>
                </div>
            </div>
            {showAddAddress ? <AddAddressModal
                show={showAddAddress}
                setShow={setShowAddAddressModal}
                onClickFn={handleAddAddress}
                onChangeFn={onHandleChange}
                formErrors={formErrors}
                // userLocation={userLocation}
                addressValues={addressValues}
                setAddressValues={setAddressValues}
                setErrorMessage={setErrorMessage}
            /> : null}

            {showEditAddress ? <EditAddressModal
                address={addressEdit}
                show={showEditAddress}
                setShow={setShowEditAddressModal}
                onClickFn={handleEditAddress}
                onChangeFn={onHandleEditChange}
                formErrors={formErrors}
                // userLocation={userLocation}
                addressValues={addressValues}
                setAddressValues={setAddressValues}
                setErrorMessage={setErrorMessage}
            /> : null}
        </div>
    );
};

export default AddressCard;
